import { Checkbox } from "@src/straps/base";
import { ClickableDiv } from "@src/straps/utils/ClickableDiv";
import { PropsWithChildren } from "react";

/** Copy goes through children because `Checkbox`'s `label` is string-typed. */
export function AgreementCheckbox({
  checked,
  onToggle,
  dataTestId,
  children,
}: PropsWithChildren<{
  readonly checked: boolean;
  readonly onToggle: () => void;
  readonly dataTestId: string;
}>) {
  return (
    <ClickableDiv className="flex items-start gap-3" onClick={onToggle}>
      <Checkbox label="" dataTestId={dataTestId} checked={checked} />
      <div className="-mt-[2px]">{children}</div>
    </ClickableDiv>
  );
}
